import TicketStats from "./ticketStats.component";

export default TicketStats;
